

import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class Klachten extends Vue {
  name!: "klachten"



}
